module.exports = __webpack_public_path__ + "img/eprf-forms.82b4e037.png";